import { Component, computed, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BriefingNotesComponent } from '@campaign-form/form-fields/creators-and-ctas/briefing-notes/briefing-notes.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SideDialogComponent } from '@shared/components/side-dialog/side-dialog.component';
import { IBriefingNotesDialogData, IBriefingNotesDialogResult } from './briefing-notes-dialog.interface';

@Component({
  imports: [BriefingNotesComponent, SideDialogComponent, TranslateModule],
  selector: 'app-briefing-notes-dialog',
  templateUrl: './briefing-notes-dialog.component.html',
})
export class BriefingNotesDialogComponent {
  private readonly data = inject<IBriefingNotesDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<BriefingNotesDialogComponent>);
  private readonly translate = inject(TranslateService);

  public readonly title = computed(() => {
    if (this.data.viewMode) {
      return this.translate.instant('components.briefingNotes.briefingNotes');
    }

    if (this.data.creatorName) {
      return this.translate.instant('components.briefingNotes.creatorTitle', {
        creatorName: this.data.creatorName,
      });
    }

    return this.translate.instant('components.briefingNotes.globalTitle');
  });

  public onCancelClick(): void {
    this.dialogRef.close();
  }

  public onSave(result: IBriefingNotesDialogResult): void {
    this.dialogRef.close(result);
  }

  public get dialogData(): IBriefingNotesDialogData {
    return this.data;
  }
}
